import * as Types from '../../../../../graphql/__generated__/globalTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentShiftForLogoutQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentShiftForLogoutQuery = { __typename?: 'Query', getCurrentShift?: { __typename?: 'Shift', id: string, startTime: any, endTime?: any | null } | null };

export type EndShiftOnLogoutMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type EndShiftOnLogoutMutation = { __typename?: 'Mutation', employeeEndShift: { __typename?: 'Shift', id: string, startTime: any } };


export const GetCurrentShiftForLogoutDocument = gql`
    query GetCurrentShiftForLogout {
  getCurrentShift {
    id
    startTime
    endTime
  }
}
    `;

/**
 * __useGetCurrentShiftForLogoutQuery__
 *
 * To run a query within a React component, call `useGetCurrentShiftForLogoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentShiftForLogoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentShiftForLogoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentShiftForLogoutQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentShiftForLogoutQuery, GetCurrentShiftForLogoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentShiftForLogoutQuery, GetCurrentShiftForLogoutQueryVariables>(GetCurrentShiftForLogoutDocument, options);
      }
export function useGetCurrentShiftForLogoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentShiftForLogoutQuery, GetCurrentShiftForLogoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentShiftForLogoutQuery, GetCurrentShiftForLogoutQueryVariables>(GetCurrentShiftForLogoutDocument, options);
        }
export function useGetCurrentShiftForLogoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentShiftForLogoutQuery, GetCurrentShiftForLogoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentShiftForLogoutQuery, GetCurrentShiftForLogoutQueryVariables>(GetCurrentShiftForLogoutDocument, options);
        }
export type GetCurrentShiftForLogoutQueryHookResult = ReturnType<typeof useGetCurrentShiftForLogoutQuery>;
export type GetCurrentShiftForLogoutLazyQueryHookResult = ReturnType<typeof useGetCurrentShiftForLogoutLazyQuery>;
export type GetCurrentShiftForLogoutSuspenseQueryHookResult = ReturnType<typeof useGetCurrentShiftForLogoutSuspenseQuery>;
export type GetCurrentShiftForLogoutQueryResult = Apollo.QueryResult<GetCurrentShiftForLogoutQuery, GetCurrentShiftForLogoutQueryVariables>;
export const EndShiftOnLogoutDocument = gql`
    mutation EndShiftOnLogout {
  employeeEndShift {
    id
    startTime
  }
}
    `;
export type EndShiftOnLogoutMutationFn = Apollo.MutationFunction<EndShiftOnLogoutMutation, EndShiftOnLogoutMutationVariables>;

/**
 * __useEndShiftOnLogoutMutation__
 *
 * To run a mutation, you first call `useEndShiftOnLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndShiftOnLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endShiftOnLogoutMutation, { data, loading, error }] = useEndShiftOnLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useEndShiftOnLogoutMutation(baseOptions?: Apollo.MutationHookOptions<EndShiftOnLogoutMutation, EndShiftOnLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndShiftOnLogoutMutation, EndShiftOnLogoutMutationVariables>(EndShiftOnLogoutDocument, options);
      }
export type EndShiftOnLogoutMutationHookResult = ReturnType<typeof useEndShiftOnLogoutMutation>;
export type EndShiftOnLogoutMutationResult = Apollo.MutationResult<EndShiftOnLogoutMutation>;
export type EndShiftOnLogoutMutationOptions = Apollo.BaseMutationOptions<EndShiftOnLogoutMutation, EndShiftOnLogoutMutationVariables>;